<template>
  <div>
    <!-- 头部 -->
    <div class="header">
      <el-form ref="form" :model="searchParams" :inline="true">
        <el-form-item label="平台">
          <el-select
            v-model="searchParams.type"
            placeholder="请选择"
            class="select"
            @change="getVersionList"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="版本">
          <el-select
            v-model="searchParams.version"
            placeholder="请选择"
            class="select"
          >
            <el-option
              v-for="(item, index) in versionShow"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- 推送 -->
          <el-button type="primary" @click="searchEvent" plain>搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-card shadow="never">
      <!-- 版本表格   :loading="loading" -->
      <my-table
        :loading="loading"
        isSelection
        :tableData="tableData"
        :tableHeader="tableHeader"
		:selectEnable="selectEnable"
        @handleSelectionChange="handleSelectionChange"
      />
      <my-pagination :childMsg="pageParams" @callFather="callFather" />
    </el-card>
    <el-button type="primary" @click="submit" plain>推送</el-button>
    <el-button @click="reset">重置</el-button>
  </div>
</template>

<script>
import {
  reqGetVersionList,
  reqSearchVersion,
  reqPushVersion,
} from "@/network/other/version";
import { canSearch } from "../../utils/utils";
import mixins from "@/mixins/common";
export default {
  name: "version",
  mixins: [mixins],
  data() {
    return {
      // 平台
      options: [
        {
          value: "1",
          label: "android",
        },
        {
          value: "2",
          label: "ios",
        },
      ],
      // 获取到的安卓和ios的版本
      versionlist: [],
      // 动态展示的版本
      versionShow: [],
      // 搜索参数
      searchParams: {
        version: "",
        type: "",
      },
      tableHeader: Object.freeze([
        {
          name: "登录用户",
          prop: "username",
        },
        {
          name: "平台",
          prop: "clientType",
        },
        {
          name: "当前版本",
          prop: "version",
        },
        {
          name: "最新版本",
          prop: "newVersion",
        },
      ]),
      checkedUser: [],
      // 推送携带字段
      ruleForm: {
        context: "尊敬的用户已检测到您的版本过低请及时更新",
        title: "更新最新版本",
        cids: [],
      },
	  selectEnable:function(val) {
			if(val.newVersion==val.version){
				return false
			}else{
				return true
			}
			
	   }
    };
  },
  methods: {
    async getData() {
      let { data } = await reqGetVersionList();
      if (data.code == 200) {
        this.versionlist = data.data;
      }
    },
    // 根据平台获取版本
    getVersionList(){
      // 清空之前展示的版本
      this.searchParams.version = "";
      this.versionShow = this.versionlist[this.searchParams.type];
    },
    async getInitData(issearch) {
      let { version, type: clientType } = this.searchParams;
      let params = {
        version,
        clientType,
        current: issearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      let { data } = await reqSearchVersion(params);
      if (data.code == 200) {
        this.tableData = data.data.records;
        this.pageParams.total = data.data.total;
        this.loading = false;
        if (issearch) this.pageParams.currentPage = 1;
      }
    },
    // 搜索
    searchEvent() {
      if (canSearch(this, this.searchParams)) return;
      this.$bus.$emit("clearSelection");
      console.log("搜索了");

      this.getInitData(true);
    },
    // 推送
    async submit() {
      if (!this.checkedUser.length) {
        this.$message({
          message: "推送用户不能为空",
          type: "warning",
        });
        return;
      }

      this.checkedUser.forEach((element) => {
        this.ruleForm.cids.push({
          type: element.clientType,
          cid: element.clientId,
		  userName:element.userName,
        });
      });
      let { data } = await reqPushVersion(this.ruleForm);
      if (data.code == 200) {
		  this.$message({
		    message:  "推送成功",
		    type: "success",
		  });
       
      } else {
        this.$message({
          message: data.msg,
          type: "warning",
        });
      }
      // 清除选中
	  this.ruleForm.cids = [];
      this.$bus.$emit("clearSelection");
    },
    // 重置
    reset() {
      this.$bus.$emit("clearSelection");
    },
    // 收集选中的用户
    handleSelectionChange(val) {
      this.checkedUser = val;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.header {
  height: 80px;
  /* background-color: #f2f2f2; */
  display: flex;
  align-items: center;
}
.el-card {
  padding-top: 20px;
  margin-bottom: 20px;
}
</style>
